import { render } from "./TestTitle.vue?vue&type=template&id=5bccb813&scoped=true"
import script from "./TestTitle.vue?vue&type=script&lang=js"
export * from "./TestTitle.vue?vue&type=script&lang=js"

import "./TestTitle.vue?vue&type=style&index=0&id=5bccb813&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bccb813"]])

export default __exports__